
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const PersonDataAccessScope = {
  ATTENDANCE: 'ATTENDANCE',
  ASSESSMENT: 'ASSESSMENT',
  CERTIFICATIONS: 'CERTIFICATIONS',
  ALL_BASIC: 'ALL_BASIC'
} as const

export type PersonDataAccessScope = (typeof PersonDataAccessScope)[keyof typeof PersonDataAccessScope]


export const PersonType = {
  STUDENT: 'STUDENT',
  STAFF: 'STAFF',
  PARENT: 'PARENT',
  COMMUNITY_MEMBER: 'COMMUNITY_MEMBER',
  CONTRACTOR: 'CONTRACTOR',
  CONSULTANT: 'CONSULTANT'
} as const

export type PersonType = (typeof PersonType)[keyof typeof PersonType]


export const AccessContext = {
  MEMBER: 'MEMBER',
  NON_MEMBER: 'NON_MEMBER',
  ANONYMOUS_EXTERNAL: 'ANONYMOUS_EXTERNAL'
} as const

export type AccessContext = (typeof AccessContext)[keyof typeof AccessContext]


export const ExternalSystem = {
  GITHUB: 'GITHUB',
  HUBSPOT: 'HUBSPOT',
  LINEAR: 'LINEAR',
  NOTION: 'NOTION',
  SLACK: 'SLACK',
  DRATA: 'DRATA',
  GMAIL: 'GMAIL',
  RIPPLING: 'RIPPLING',
  POWERSCHOOL: 'POWERSCHOOL',
  INFINITE_CAMPUS: 'INFINITE_CAMPUS',
  SKYWARD: 'SKYWARD',
  ED_FI: 'ED_FI'
} as const

export type ExternalSystem = (typeof ExternalSystem)[keyof typeof ExternalSystem]


export const ExternalIdentitySource = {
  EMAIL_AUTO_MATCH: 'EMAIL_AUTO_MATCH',
  ADMIN_OVERRIDE: 'ADMIN_OVERRIDE',
  HRIS_SYNC: 'HRIS_SYNC',
  SIS_SYNC: 'SIS_SYNC'
} as const

export type ExternalIdentitySource = (typeof ExternalIdentitySource)[keyof typeof ExternalIdentitySource]


export const ExternalIdType = {
  STATE_STUDENT_ID: 'STATE_STUDENT_ID',
  LOCAL_STUDENT_NUMBER: 'LOCAL_STUDENT_NUMBER',
  VENDOR_GUID: 'VENDOR_GUID'
} as const

export type ExternalIdType = (typeof ExternalIdType)[keyof typeof ExternalIdType]


export const EmailAliasSource = {
  PRIMARY: 'PRIMARY',
  RIPPLING: 'RIPPLING',
  GOOGLE: 'GOOGLE',
  MANUAL: 'MANUAL'
} as const

export type EmailAliasSource = (typeof EmailAliasSource)[keyof typeof EmailAliasSource]


export const ThemePreference = {
  SYSTEM: 'SYSTEM',
  LIGHT: 'LIGHT',
  DARK: 'DARK'
} as const

export type ThemePreference = (typeof ThemePreference)[keyof typeof ThemePreference]


export const TimezoneMode = {
  AUTOMATIC: 'AUTOMATIC',
  ASK: 'ASK',
  MANUAL: 'MANUAL'
} as const

export type TimezoneMode = (typeof TimezoneMode)[keyof typeof TimezoneMode]


export const SynopsisMode = {
  OFF: 'OFF',
  OPT_IN: 'OPT_IN',
  OPT_OUT: 'OPT_OUT'
} as const

export type SynopsisMode = (typeof SynopsisMode)[keyof typeof SynopsisMode]


export const SynopsisPreference = {
  INHERIT: 'INHERIT',
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED'
} as const

export type SynopsisPreference = (typeof SynopsisPreference)[keyof typeof SynopsisPreference]


export const OrgType = {
  LIVE: 'LIVE',
  DEMO: 'DEMO',
  TRIAL: 'TRIAL'
} as const

export type OrgType = (typeof OrgType)[keyof typeof OrgType]


export const OrgKind = {
  INDEPENDENT: 'INDEPENDENT',
  STATE_ED_AGENCY: 'STATE_ED_AGENCY',
  ED_SERVICE_CENTER: 'ED_SERVICE_CENTER',
  LOCAL_ED_AGENCY: 'LOCAL_ED_AGENCY',
  SCHOOL: 'SCHOOL',
  COMPANY: 'COMPANY',
  DIVISION: 'DIVISION',
  DEPARTMENT: 'DEPARTMENT',
  TEAM: 'TEAM'
} as const

export type OrgKind = (typeof OrgKind)[keyof typeof OrgKind]


export const OrgRole = {
  OWNER: 'OWNER',
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
  VIEWER: 'VIEWER',
  TRACKED: 'TRACKED'
} as const

export type OrgRole = (typeof OrgRole)[keyof typeof OrgRole]


export const MemberStatus = {
  ACTIVE: 'ACTIVE',
  INVITED: 'INVITED',
  SUSPENDED: 'SUSPENDED'
} as const

export type MemberStatus = (typeof MemberStatus)[keyof typeof MemberStatus]


export const FlagScope = {
  GLOBAL: 'GLOBAL',
  ORG: 'ORG'
} as const

export type FlagScope = (typeof FlagScope)[keyof typeof FlagScope]


export const PlatformRole = {
  NONE: 'NONE',
  PLATFORM_ADMIN: 'PLATFORM_ADMIN',
  DEMO_PLATFORM_ADMIN: 'DEMO_PLATFORM_ADMIN'
} as const

export type PlatformRole = (typeof PlatformRole)[keyof typeof PlatformRole]


export const Status = {
  RED: 'RED',
  YELLOW: 'YELLOW',
  GREEN: 'GREEN',
  BLUE: 'BLUE',
  UNKNOWN: 'UNKNOWN'
} as const

export type Status = (typeof Status)[keyof typeof Status]


export const ContractorRecommendation = {
  CONTINUE: 'CONTINUE',
  PAUSE: 'PAUSE',
  TERMINATE: 'TERMINATE'
} as const

export type ContractorRecommendation = (typeof ContractorRecommendation)[keyof typeof ContractorRecommendation]


export const ValueExceptionDirection = {
  ABOVE_BAR: 'ABOVE_BAR',
  BELOW_BAR: 'BELOW_BAR'
} as const

export type ValueExceptionDirection = (typeof ValueExceptionDirection)[keyof typeof ValueExceptionDirection]


export const ItemState = {
  pending: 'pending',
  new: 'new',
  active: 'active',
  needs_update: 'needs_update',
  completed: 'completed',
  cancelled: 'cancelled',
  deleted: 'deleted'
} as const

export type ItemState = (typeof ItemState)[keyof typeof ItemState]


export const EntityType = {
  ROCK: 'ROCK',
  PERSON: 'PERSON',
  GROUP: 'GROUP',
  GOAL: 'GOAL',
  MEASURABLE: 'MEASURABLE',
  PLAN: 'PLAN',
  PLAN_ITEM: 'PLAN_ITEM',
  REFLECTION: 'REFLECTION',
  CUSTOMER: 'CUSTOMER',
  CONTRACT: 'CONTRACT',
  PERFORMANCE_REVIEW: 'PERFORMANCE_REVIEW',
  PROJECT: 'PROJECT',
  TASK: 'TASK',
  ASSESSMENT_RESPONSE: 'ASSESSMENT_RESPONSE',
  ASSESSMENT_ACCOMMODATION: 'ASSESSMENT_ACCOMMODATION',
  ATTENDANCE_RECORD: 'ATTENDANCE_RECORD',
  MEETING: 'MEETING',
  MEETING_HIGHLIGHT: 'MEETING_HIGHLIGHT',
  DISCIPLINE_INCIDENT: 'DISCIPLINE_INCIDENT',
  STUDENT_DISCIPLINE_INCIDENT_ASSOCIATION: 'STUDENT_DISCIPLINE_INCIDENT_ASSOCIATION',
  DISCIPLINE_ACTION: 'DISCIPLINE_ACTION',
  STUDENT_DEMOGRAPHIC: 'STUDENT_DEMOGRAPHIC',
  STUDENT_RACE: 'STUDENT_RACE',
  ACADEMIC_TERM: 'ACADEMIC_TERM',
  BEHAVIOR_INCIDENT: 'BEHAVIOR_INCIDENT',
  SCHOOL_CALENDAR: 'SCHOOL_CALENDAR',
  SCHOOL_CALENDAR_DATE: 'SCHOOL_CALENDAR_DATE',
  COURSE: 'COURSE',
  COURSE_SECTION: 'COURSE_SECTION',
  SECTION_ROSTER: 'SECTION_ROSTER',
  ISSUE: 'ISSUE',
  STUDENT_ACADEMIC_RECORD_GRADE: 'STUDENT_ACADEMIC_RECORD_GRADE',
  PRIORITY: 'PRIORITY',
  STRATEGIC_PLAN: 'STRATEGIC_PLAN',
  BELIEF: 'BELIEF'
} as const

export type EntityType = (typeof EntityType)[keyof typeof EntityType]


export const ChangeAction = {
  CREATED: 'CREATED',
  UPDATED: 'UPDATED',
  DELETED: 'DELETED',
  PARENT_CHANGED: 'PARENT_CHANGED',
  STATE_CHANGED: 'STATE_CHANGED',
  STATUS_CHANGED: 'STATUS_CHANGED',
  TYPE_CONVERTED: 'TYPE_CONVERTED',
  CREATED_FROM_CONVERSION: 'CREATED_FROM_CONVERSION'
} as const

export type ChangeAction = (typeof ChangeAction)[keyof typeof ChangeAction]


export const CoreValue = {
  RISE_TO_THE_MOMENT: 'RISE_TO_THE_MOMENT',
  RUN_AT_THE_BEAR: 'RUN_AT_THE_BEAR',
  SIMPLIFY_AND_GO: 'SIMPLIFY_AND_GO',
  CONNECT_THE_DOTS: 'CONNECT_THE_DOTS',
  HAVE_FUN_WINNING_TOGETHER: 'HAVE_FUN_WINNING_TOGETHER',
  FIND_LEVERAGE: 'FIND_LEVERAGE',
  OVERWHELM_CONSTRAINTS: 'OVERWHELM_CONSTRAINTS',
  MAKE_MAGIC: 'MAKE_MAGIC'
} as const

export type CoreValue = (typeof CoreValue)[keyof typeof CoreValue]


export const REKSDimension = {
  RESULTS: 'RESULTS',
  EFFORT: 'EFFORT',
  KNOWLEDGE: 'KNOWLEDGE',
  SKILLS: 'SKILLS',
  VALUES: 'VALUES'
} as const

export type REKSDimension = (typeof REKSDimension)[keyof typeof REKSDimension]


export const ReviewType = {
  SELF: 'SELF',
  MANAGER: 'MANAGER',
  TEAM_LEAD: 'TEAM_LEAD',
  PEER: 'PEER',
  SKIP_LEVEL: 'SKIP_LEVEL',
  UPWARD: 'UPWARD',
  CROSS_FUNCTIONAL: 'CROSS_FUNCTIONAL',
  MENTOR: 'MENTOR'
} as const

export type ReviewType = (typeof ReviewType)[keyof typeof ReviewType]


export const NominationStatus = {
  PROPOSED: 'PROPOSED',
  APPROVED: 'APPROVED',
  DECLINED: 'DECLINED',
  COMPLETED: 'COMPLETED'
} as const

export type NominationStatus = (typeof NominationStatus)[keyof typeof NominationStatus]


export const QuarterlyReviewStatus = {
  DRAFT: 'DRAFT',
  PENDING_EXECUTIVE: 'PENDING_EXECUTIVE',
  CALIBRATED: 'CALIBRATED',
  APPROVED: 'APPROVED',
  SHARED: 'SHARED'
} as const

export type QuarterlyReviewStatus = (typeof QuarterlyReviewStatus)[keyof typeof QuarterlyReviewStatus]


export const CadenceKey = {
  MONTHLY_CHECK_IN: 'MONTHLY_CHECK_IN',
  QUARTERLY_REVIEW: 'QUARTERLY_REVIEW',
  SELF_REFLECTION: 'SELF_REFLECTION',
  WEEKLY_PULSE: 'WEEKLY_PULSE'
} as const

export type CadenceKey = (typeof CadenceKey)[keyof typeof CadenceKey]


export const BonusPeriodStatus = {
  DRAFT: 'DRAFT',
  REVIEWING: 'REVIEWING',
  FINALIZED: 'FINALIZED'
} as const

export type BonusPeriodStatus = (typeof BonusPeriodStatus)[keyof typeof BonusPeriodStatus]


export const BonusPeriodType = {
  PERSONAL_QUARTERLY: 'PERSONAL_QUARTERLY',
  COMPANY_ANNUAL: 'COMPANY_ANNUAL'
} as const

export type BonusPeriodType = (typeof BonusPeriodType)[keyof typeof BonusPeriodType]


export const ReplyParentType = {
  UPDATE: 'UPDATE',
  CHANGELOG: 'CHANGELOG',
  COMMENT: 'COMMENT'
} as const

export type ReplyParentType = (typeof ReplyParentType)[keyof typeof ReplyParentType]


export const ReactionTargetType = {
  COMMENT: 'COMMENT',
  REPLY: 'REPLY',
  UPDATE: 'UPDATE',
  REFLECTION: 'REFLECTION',
  MEETING_HIGHLIGHT: 'MEETING_HIGHLIGHT',
  BELIEF: 'BELIEF'
} as const

export type ReactionTargetType = (typeof ReactionTargetType)[keyof typeof ReactionTargetType]


export const DashboardItemType = {
  METRIC: 'METRIC',
  DELIVERABLE: 'DELIVERABLE',
  PROCESS: 'PROCESS',
  EVENT: 'EVENT',
  COMPLIANCE: 'COMPLIANCE',
  INTEGRATION: 'INTEGRATION',
  INFRASTRUCTURE: 'INFRASTRUCTURE',
  PLANNING: 'PLANNING',
  STRATEGY: 'STRATEGY'
} as const

export type DashboardItemType = (typeof DashboardItemType)[keyof typeof DashboardItemType]


export const ItemType = {
  ROCK: 'ROCK',
  GROUP: 'GROUP',
  PROJECT: 'PROJECT'
} as const

export type ItemType = (typeof ItemType)[keyof typeof ItemType]


export const FeedbackType = {
  BUG: 'BUG',
  SUGGESTION: 'SUGGESTION',
  QUESTION: 'QUESTION',
  PRAISE: 'PRAISE'
} as const

export type FeedbackType = (typeof FeedbackType)[keyof typeof FeedbackType]


export const FeedbackStatus = {
  NEW: 'NEW',
  ISSUE_CREATED: 'ISSUE_CREATED',
  ACKNOWLEDGED: 'ACKNOWLEDGED',
  PLANNED: 'PLANNED',
  DEFERRED: 'DEFERRED',
  IMPLEMENTING: 'IMPLEMENTING',
  RESOLVED: 'RESOLVED',
  CLOSED: 'CLOSED',
  REVIEWED: 'REVIEWED',
  FLAGGED_FOR_REVIEW: 'FLAGGED_FOR_REVIEW'
} as const

export type FeedbackStatus = (typeof FeedbackStatus)[keyof typeof FeedbackStatus]


export const FeedbackActivityType = {
  STATUS_CHANGE: 'STATUS_CHANGE',
  LINKED_ISSUE: 'LINKED_ISSUE',
  LINKED_PR: 'LINKED_PR'
} as const

export type FeedbackActivityType = (typeof FeedbackActivityType)[keyof typeof FeedbackActivityType]


export const PlanStatus = {
  DRAFT: 'DRAFT',
  PENDING_ACCEPTANCE: 'PENDING_ACCEPTANCE',
  ACTIVATING: 'ACTIVATING',
  ACTIVE: 'ACTIVE',
  ABANDONED: 'ABANDONED'
} as const

export type PlanStatus = (typeof PlanStatus)[keyof typeof PlanStatus]


export const AcceptanceStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  CONCERNS: 'CONCERNS'
} as const

export type AcceptanceStatus = (typeof AcceptanceStatus)[keyof typeof AcceptanceStatus]


export const ProposalState = {
  PROPOSED: 'PROPOSED',
  CONFIRMED: 'CONFIRMED',
  REVERTED: 'REVERTED'
} as const

export type ProposalState = (typeof ProposalState)[keyof typeof ProposalState]


export const PlanItemMergeDecision = {
  PENDING: 'PENDING',
  CREATE_NEW: 'CREATE_NEW',
  MAP_EXISTING: 'MAP_EXISTING',
  SKIP: 'SKIP'
} as const

export type PlanItemMergeDecision = (typeof PlanItemMergeDecision)[keyof typeof PlanItemMergeDecision]


export const PlanType = {
  SESSION: 'SESSION',
  INBOX: 'INBOX'
} as const

export type PlanType = (typeof PlanType)[keyof typeof PlanType]


export const PlanTargetType = {
  ROCK: 'ROCK',
  GROUP: 'GROUP',
  PROJECT: 'PROJECT',
  TASK: 'TASK'
} as const

export type PlanTargetType = (typeof PlanTargetType)[keyof typeof PlanTargetType]


export const PlanLabelEntityKind = {
  ROCK: 'ROCK',
  PROJECT: 'PROJECT',
  TASK: 'TASK',
  GROUP: 'GROUP'
} as const

export type PlanLabelEntityKind = (typeof PlanLabelEntityKind)[keyof typeof PlanLabelEntityKind]


export const IdeaHistoryStatus = {
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  MOVED: 'MOVED'
} as const

export type IdeaHistoryStatus = (typeof IdeaHistoryStatus)[keyof typeof IdeaHistoryStatus]


export const BoardMemberRole = {
  CHAIR: 'CHAIR',
  MEMBER: 'MEMBER',
  OBSERVER: 'OBSERVER'
} as const

export type BoardMemberRole = (typeof BoardMemberRole)[keyof typeof BoardMemberRole]


export const BoardAccessTier = {
  FULL: 'FULL',
  STANDARD: 'STANDARD',
  LIMITED: 'LIMITED'
} as const

export type BoardAccessTier = (typeof BoardAccessTier)[keyof typeof BoardAccessTier]


export const BoardPortalActivityAction = {
  VIEW: 'VIEW',
  DOWNLOAD: 'DOWNLOAD',
  TIME_SPENT: 'TIME_SPENT',
  PRE_READ_COMPLETE: 'PRE_READ_COMPLETE'
} as const

export type BoardPortalActivityAction = (typeof BoardPortalActivityAction)[keyof typeof BoardPortalActivityAction]


export const GitHubAppAccountType = {
  Organization: 'Organization',
  User: 'User'
} as const

export type GitHubAppAccountType = (typeof GitHubAppAccountType)[keyof typeof GitHubAppAccountType]


export const GitHubAppRepositorySelection = {
  all: 'all',
  selected: 'selected'
} as const

export type GitHubAppRepositorySelection = (typeof GitHubAppRepositorySelection)[keyof typeof GitHubAppRepositorySelection]


export const ConversationSubjectType = {
  WEEKLY_REFLECTION: 'WEEKLY_REFLECTION',
  REVIEW_PERIOD: 'REVIEW_PERIOD',
  QUARTERLY_REVIEW: 'QUARTERLY_REVIEW',
  PULSE: 'PULSE',
  ORG_PAGE: 'ORG_PAGE'
} as const

export type ConversationSubjectType = (typeof ConversationSubjectType)[keyof typeof ConversationSubjectType]


export const PulseConversationSource = {
  CONVERSATION: 'CONVERSATION',
  WRITE_EXTRACTION: 'WRITE_EXTRACTION'
} as const

export type PulseConversationSource = (typeof PulseConversationSource)[keyof typeof PulseConversationSource]


export const PulseConversationStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  REVIEWING: 'REVIEWING',
  COMPLETED: 'COMPLETED',
  ABANDONED: 'ABANDONED'
} as const

export type PulseConversationStatus = (typeof PulseConversationStatus)[keyof typeof PulseConversationStatus]


export const PulseConversationMemoryType = {
  THEME: 'THEME',
  COMMITMENT: 'COMMITMENT',
  SENTIMENT_TREND: 'SENTIMENT_TREND',
  GROWTH: 'GROWTH',
  RECURRING_BLOCKER: 'RECURRING_BLOCKER'
} as const

export type PulseConversationMemoryType = (typeof PulseConversationMemoryType)[keyof typeof PulseConversationMemoryType]


export const AiBeliefCorrectionSurface = {
  PULSE_CONVERSATION: 'PULSE_CONVERSATION',
  AI_CHAT: 'AI_CHAT',
  SYNOPSIS: 'SYNOPSIS'
} as const

export type AiBeliefCorrectionSurface = (typeof AiBeliefCorrectionSurface)[keyof typeof AiBeliefCorrectionSurface]


export const AiBeliefCorrectionCategory = {
  OWNERSHIP: 'OWNERSHIP',
  ROLE: 'ROLE',
  CHARTER: 'CHARTER',
  METRIC_CURRENCY: 'METRIC_CURRENCY',
  APPLICABILITY: 'APPLICABILITY',
  RELATIONSHIP: 'RELATIONSHIP',
  OTHER: 'OTHER'
} as const

export type AiBeliefCorrectionCategory = (typeof AiBeliefCorrectionCategory)[keyof typeof AiBeliefCorrectionCategory]


export const AiBeliefCorrectionStatus = {
  ACTIVE: 'ACTIVE',
  SUPERSEDED: 'SUPERSEDED',
  DISMISSED: 'DISMISSED'
} as const

export type AiBeliefCorrectionStatus = (typeof AiBeliefCorrectionStatus)[keyof typeof AiBeliefCorrectionStatus]


export const NotificationPriority = {
  LOW: 'LOW',
  NORMAL: 'NORMAL',
  HIGH: 'HIGH',
  URGENT: 'URGENT'
} as const

export type NotificationPriority = (typeof NotificationPriority)[keyof typeof NotificationPriority]


export const NotificationChannel = {
  IN_APP: 'IN_APP',
  EMAIL: 'EMAIL',
  SLACK: 'SLACK',
  SMS: 'SMS'
} as const

export type NotificationChannel = (typeof NotificationChannel)[keyof typeof NotificationChannel]


export const DeliveryStatus = {
  PENDING: 'PENDING',
  SENT: 'SENT',
  FAILED: 'FAILED',
  SKIPPED: 'SKIPPED'
} as const

export type DeliveryStatus = (typeof DeliveryStatus)[keyof typeof DeliveryStatus]


export const PerformanceAlertType = {
  METRIC_DECLINING: 'METRIC_DECLINING',
  METRIC_OFF_TRACK: 'METRIC_OFF_TRACK',
  REKS_DECLINING: 'REKS_DECLINING',
  TEAM_MEMBER_AT_RISK: 'TEAM_MEMBER_AT_RISK',
  TEAM_METRIC_OFF_TRACK: 'TEAM_METRIC_OFF_TRACK',
  DATA_COMPLIANCE: 'DATA_COMPLIANCE',
  REVIEW_DUE: 'REVIEW_DUE',
  REVIEW_PENDING: 'REVIEW_PENDING'
} as const

export type PerformanceAlertType = (typeof PerformanceAlertType)[keyof typeof PerformanceAlertType]


export const AlertSeverity = {
  INFO: 'INFO',
  WARNING: 'WARNING',
  CRITICAL: 'CRITICAL'
} as const

export type AlertSeverity = (typeof AlertSeverity)[keyof typeof AlertSeverity]


export const TrainingAssignmentStatus = {
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
  PAUSED: 'PAUSED'
} as const

export type TrainingAssignmentStatus = (typeof TrainingAssignmentStatus)[keyof typeof TrainingAssignmentStatus]


export const TrainingCompletionSource = {
  AUTOMATIC: 'AUTOMATIC',
  WALKTHROUGH: 'WALKTHROUGH',
  MANUAL: 'MANUAL'
} as const

export type TrainingCompletionSource = (typeof TrainingCompletionSource)[keyof typeof TrainingCompletionSource]


export const CoachingTopicSource = {
  GAP_ANALYSIS: 'GAP_ANALYSIS',
  AI_SYNTHESIS: 'AI_SYNTHESIS',
  PEER_FEEDBACK: 'PEER_FEEDBACK',
  MANUAL: 'MANUAL'
} as const

export type CoachingTopicSource = (typeof CoachingTopicSource)[keyof typeof CoachingTopicSource]


export const CoachingTopicStatus = {
  PENDING: 'PENDING',
  DISCUSSED: 'DISCUSSED',
  DEFERRED: 'DEFERRED',
  ACTION_ITEM: 'ACTION_ITEM'
} as const

export type CoachingTopicStatus = (typeof CoachingTopicStatus)[keyof typeof CoachingTopicStatus]


export const FeedbackValue = {
  UP: 'UP',
  DOWN: 'DOWN'
} as const

export type FeedbackValue = (typeof FeedbackValue)[keyof typeof FeedbackValue]


export const SurveyStatus = {
  DRAFT: 'DRAFT',
  SCHEDULED: 'SCHEDULED',
  ACTIVE: 'ACTIVE',
  CLOSED: 'CLOSED',
  ARCHIVED: 'ARCHIVED'
} as const

export type SurveyStatus = (typeof SurveyStatus)[keyof typeof SurveyStatus]


export const SurveyTriggerType = {
  MANUAL: 'MANUAL',
  AFTER_PULSE_CHECK: 'AFTER_PULSE_CHECK',
  AFTER_MEETING: 'AFTER_MEETING',
  RECURRING: 'RECURRING'
} as const

export type SurveyTriggerType = (typeof SurveyTriggerType)[keyof typeof SurveyTriggerType]


export const SurveyQuestionType = {
  RATING: 'RATING',
  FREE_TEXT: 'FREE_TEXT',
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  NPS: 'NPS',
  RANKING: 'RANKING',
  MATRIX: 'MATRIX'
} as const

export type SurveyQuestionType = (typeof SurveyQuestionType)[keyof typeof SurveyQuestionType]


export const SurveyRecipientStatus = {
  PENDING: 'PENDING',
  AWAITING_TRIGGER: 'AWAITING_TRIGGER',
  NOTIFIED: 'NOTIFIED',
  COMPLETED: 'COMPLETED',
  SKIPPED: 'SKIPPED'
} as const

export type SurveyRecipientStatus = (typeof SurveyRecipientStatus)[keyof typeof SurveyRecipientStatus]


export const SurveySentiment = {
  POSITIVE: 'POSITIVE',
  NEUTRAL: 'NEUTRAL',
  NEGATIVE: 'NEGATIVE',
  MIXED: 'MIXED'
} as const

export type SurveySentiment = (typeof SurveySentiment)[keyof typeof SurveySentiment]


export const SurveyBucketGranularity = {
  HOUR: 'HOUR',
  DAY: 'DAY',
  WEEK: 'WEEK'
} as const

export type SurveyBucketGranularity = (typeof SurveyBucketGranularity)[keyof typeof SurveyBucketGranularity]


export const SequenceEventType = {
  PERSON_START_DATE: 'PERSON_START_DATE',
  PROMOTION: 'PROMOTION',
  ROLE_CHANGE: 'ROLE_CHANGE',
  GROUP_JOIN: 'GROUP_JOIN'
} as const

export type SequenceEventType = (typeof SequenceEventType)[keyof typeof SequenceEventType]


export const SequenceEnrollmentStatus = {
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED'
} as const

export type SequenceEnrollmentStatus = (typeof SequenceEnrollmentStatus)[keyof typeof SequenceEnrollmentStatus]


export const SequenceStepExecutionStatus = {
  PENDING: 'PENDING',
  SENT: 'SENT',
  SKIPPED: 'SKIPPED',
  COMPLETED: 'COMPLETED'
} as const

export type SequenceStepExecutionStatus = (typeof SequenceStepExecutionStatus)[keyof typeof SequenceStepExecutionStatus]


export const TaskDefaultAssigneeType = {
  UNASSIGNED: 'UNASSIGNED',
  CAPTAIN: 'CAPTAIN',
  CREATOR: 'CREATOR',
  SPECIFIC_PERSON: 'SPECIFIC_PERSON'
} as const

export type TaskDefaultAssigneeType = (typeof TaskDefaultAssigneeType)[keyof typeof TaskDefaultAssigneeType]


export const TaskDefaultDueDateOffset = {
  TODAY: 'TODAY',
  TOMORROW: 'TOMORROW',
  THIS_FRIDAY: 'THIS_FRIDAY',
  NEXT_MONDAY: 'NEXT_MONDAY',
  NEXT_FRIDAY: 'NEXT_FRIDAY'
} as const

export type TaskDefaultDueDateOffset = (typeof TaskDefaultDueDateOffset)[keyof typeof TaskDefaultDueDateOffset]


export const QuarterReviewType = {
  THIRTY_DAY: 'THIRTY_DAY',
  NINETY_DAY: 'NINETY_DAY'
} as const

export type QuarterReviewType = (typeof QuarterReviewType)[keyof typeof QuarterReviewType]


export const RockDisposition = {
  COMPLETED: 'COMPLETED',
  ROLLING_FORWARD: 'ROLLING_FORWARD',
  DELIBERATELY_DEPRIORITIZED: 'DELIBERATELY_DEPRIORITIZED',
  BLOCKED_EXTERNALLY: 'BLOCKED_EXTERNALLY',
  MISSED: 'MISSED'
} as const

export type RockDisposition = (typeof RockDisposition)[keyof typeof RockDisposition]


export const CalibrationCycleStatus = {
  NOT_STARTED: 'NOT_STARTED',
  PREPARING: 'PREPARING',
  ACTIVE: 'ACTIVE',
  CLOSED: 'CLOSED'
} as const

export type CalibrationCycleStatus = (typeof CalibrationCycleStatus)[keyof typeof CalibrationCycleStatus]


export const CalibrationNoteType = {
  FLAG: 'FLAG',
  GUIDANCE: 'GUIDANCE',
  OBSERVATION: 'OBSERVATION'
} as const

export type CalibrationNoteType = (typeof CalibrationNoteType)[keyof typeof CalibrationNoteType]


export const LevelProposalStatus = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  WITHDRAWN: 'WITHDRAWN'
} as const

export type LevelProposalStatus = (typeof LevelProposalStatus)[keyof typeof LevelProposalStatus]


export const SourceSystem = {
  SCIM: 'SCIM',
  SIS: 'SIS',
  ED_FI: 'ED_FI',
  HR: 'HR',
  CRM: 'CRM',
  MANUAL: 'MANUAL',
  CONTEXT_RESEARCH: 'CONTEXT_RESEARCH'
} as const

export type SourceSystem = (typeof SourceSystem)[keyof typeof SourceSystem]


export const SyncDirection = {
  INBOUND: 'INBOUND',
  OUTBOUND: 'OUTBOUND',
  BIDIRECTIONAL: 'BIDIRECTIONAL'
} as const

export type SyncDirection = (typeof SyncDirection)[keyof typeof SyncDirection]


export const SyncOutcome = {
  APPLIED: 'APPLIED',
  SKIPPED_MANUAL_OVERRIDE: 'SKIPPED_MANUAL_OVERRIDE',
  CONFLICT_DETECTED: 'CONFLICT_DETECTED',
  ERROR: 'ERROR',
  MANUAL_OVERRIDE_CLEARED: 'MANUAL_OVERRIDE_CLEARED'
} as const

export type SyncOutcome = (typeof SyncOutcome)[keyof typeof SyncOutcome]


export const PipStatus = {
  DRAFT: 'DRAFT',
  SHARED: 'SHARED',
  EMPLOYEE_ACK: 'EMPLOYEE_ACK',
  ACTIVE: 'ACTIVE',
  CLOSED_MET: 'CLOSED_MET',
  CLOSED_NOT_MET: 'CLOSED_NOT_MET',
  CLOSED_EXTENDED: 'CLOSED_EXTENDED'
} as const

export type PipStatus = (typeof PipStatus)[keyof typeof PipStatus]


export const PipRequestStatus = {
  PENDING: 'PENDING',
  CONVERTED: 'CONVERTED',
  WITHDRAWN: 'WITHDRAWN'
} as const

export type PipRequestStatus = (typeof PipRequestStatus)[keyof typeof PipRequestStatus]


export const PipOutcome = {
  MET: 'MET',
  NOT_MET: 'NOT_MET',
  EXTENDED: 'EXTENDED'
} as const

export type PipOutcome = (typeof PipOutcome)[keyof typeof PipOutcome]


export const PipStatusSourceType = {
  PERFORMANCE_REVIEW: 'PERFORMANCE_REVIEW',
  QUARTERLY_PERFORMANCE_REVIEW: 'QUARTERLY_PERFORMANCE_REVIEW'
} as const

export type PipStatusSourceType = (typeof PipStatusSourceType)[keyof typeof PipStatusSourceType]


export const PipSignatureRole = {
  EMPLOYEE: 'EMPLOYEE',
  MANAGER: 'MANAGER'
} as const

export type PipSignatureRole = (typeof PipSignatureRole)[keyof typeof PipSignatureRole]


export const PipActivityAction = {
  CREATED: 'CREATED',
  FIELD_EDITED: 'FIELD_EDITED',
  SHARED: 'SHARED',
  REVERTED_TO_DRAFT: 'REVERTED_TO_DRAFT',
  BLOCKER_EDITED: 'BLOCKER_EDITED',
  EMPLOYEE_SIGNED: 'EMPLOYEE_SIGNED',
  MANAGER_SIGNED: 'MANAGER_SIGNED',
  ACTIVATED: 'ACTIVATED',
  WEEKLY_REVIEW_UPDATED: 'WEEKLY_REVIEW_UPDATED',
  MEASURABLE_SNAPSHOT_UPDATED: 'MEASURABLE_SNAPSHOT_UPDATED',
  MEASURABLE_ATTACHED: 'MEASURABLE_ATTACHED',
  MEASURABLE_DETACHED: 'MEASURABLE_DETACHED',
  MEASURABLE_TARGET_UPDATED: 'MEASURABLE_TARGET_UPDATED',
  CLOSED: 'CLOSED',
  EXTENDED: 'EXTENDED',
  SOFT_DELETED: 'SOFT_DELETED',
  REQUEST_CREATED: 'REQUEST_CREATED',
  REQUEST_WITHDRAWN: 'REQUEST_WITHDRAWN',
  REQUEST_CONVERTED: 'REQUEST_CONVERTED'
} as const

export type PipActivityAction = (typeof PipActivityAction)[keyof typeof PipActivityAction]


export const CertificationStatus = {
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  REVOKED: 'REVOKED'
} as const

export type CertificationStatus = (typeof CertificationStatus)[keyof typeof CertificationStatus]


export const AttendanceStatus = {
  PRESENT: 'PRESENT',
  EXCUSED_ABSENCE: 'EXCUSED_ABSENCE',
  UNEXCUSED_ABSENCE: 'UNEXCUSED_ABSENCE',
  TARDY: 'TARDY',
  EARLY_DEPARTURE: 'EARLY_DEPARTURE',
  OTHER: 'OTHER'
} as const

export type AttendanceStatus = (typeof AttendanceStatus)[keyof typeof AttendanceStatus]


export const ScoringModel = {
  RAW: 'RAW',
  SCALE: 'SCALE',
  PROFICIENCY: 'PROFICIENCY'
} as const

export type ScoringModel = (typeof ScoringModel)[keyof typeof ScoringModel]


export const ProficiencyLevel = {
  BELOW_BASIC: 'BELOW_BASIC',
  BASIC: 'BASIC',
  PROFICIENT: 'PROFICIENT',
  ADVANCED: 'ADVANCED'
} as const

export type ProficiencyLevel = (typeof ProficiencyLevel)[keyof typeof ProficiencyLevel]


export const AccommodationType = {
  EXTENDED_TIME: 'EXTENDED_TIME',
  ORAL_PRESENTATION: 'ORAL_PRESENTATION',
  ORAL_RESPONSE: 'ORAL_RESPONSE',
  LARGE_PRINT: 'LARGE_PRINT',
  BRAILLE: 'BRAILLE',
  ASSISTIVE_TECHNOLOGY: 'ASSISTIVE_TECHNOLOGY',
  SMALL_GROUP_SETTING: 'SMALL_GROUP_SETTING',
  SEPARATE_ROOM: 'SEPARATE_ROOM',
  BREAKS: 'BREAKS',
  OTHER: 'OTHER'
} as const

export type AccommodationType = (typeof AccommodationType)[keyof typeof AccommodationType]


export const MeetingAttendeeSource = {
  CALENDAR: 'CALENDAR',
  AOR: 'AOR',
  MANUAL: 'MANUAL',
  BACKFILL: 'BACKFILL',
  UNIT: 'UNIT',
  OUTCOME: 'OUTCOME'
} as const

export type MeetingAttendeeSource = (typeof MeetingAttendeeSource)[keyof typeof MeetingAttendeeSource]


export const MeetingPhase = {
  PRE: 'PRE',
  LIVE: 'LIVE',
  WRAP: 'WRAP',
  DONE: 'DONE'
} as const

export type MeetingPhase = (typeof MeetingPhase)[keyof typeof MeetingPhase]


export const MeetingSectionLegacy = {
  SEGUE: 'SEGUE',
  SCORECARD: 'SCORECARD',
  WORK_REVIEW: 'WORK_REVIEW',
  HEADLINES: 'HEADLINES',
  TODOS: 'TODOS',
  IDS: 'IDS',
  WRAP: 'WRAP'
} as const

export type MeetingSectionLegacy = (typeof MeetingSectionLegacy)[keyof typeof MeetingSectionLegacy]


export const DisciplineIncidentType = {
  FIGHTING: 'FIGHTING',
  TRUANCY: 'TRUANCY',
  WEAPONS: 'WEAPONS',
  DRUGS: 'DRUGS',
  BULLYING: 'BULLYING',
  THEFT: 'THEFT',
  VANDALISM: 'VANDALISM',
  OTHER: 'OTHER'
} as const

export type DisciplineIncidentType = (typeof DisciplineIncidentType)[keyof typeof DisciplineIncidentType]


export const BehavioralRole = {
  PERPETRATOR: 'PERPETRATOR',
  VICTIM: 'VICTIM',
  WITNESS: 'WITNESS',
  REPORTER: 'REPORTER',
  OTHER: 'OTHER'
} as const

export type BehavioralRole = (typeof BehavioralRole)[keyof typeof BehavioralRole]


export const DisciplineActionType = {
  SUSPENSION_IN_SCHOOL: 'SUSPENSION_IN_SCHOOL',
  SUSPENSION_OUT_OF_SCHOOL: 'SUSPENSION_OUT_OF_SCHOOL',
  EXPULSION: 'EXPULSION',
  DETENTION: 'DETENTION',
  COUNSELING_REFERRAL: 'COUNSELING_REFERRAL',
  WARNING: 'WARNING',
  OTHER: 'OTHER'
} as const

export type DisciplineActionType = (typeof DisciplineActionType)[keyof typeof DisciplineActionType]


export const BehaviorCategory = {
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE',
  NEUTRAL: 'NEUTRAL'
} as const

export type BehaviorCategory = (typeof BehaviorCategory)[keyof typeof BehaviorCategory]


export const BehaviorSeverity = {
  MINOR: 'MINOR',
  MODERATE: 'MODERATE',
  MAJOR: 'MAJOR',
  NOT_APPLICABLE: 'NOT_APPLICABLE'
} as const

export type BehaviorSeverity = (typeof BehaviorSeverity)[keyof typeof BehaviorSeverity]


export const Gender = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  NONBINARY: 'NONBINARY',
  NOT_REPORTED: 'NOT_REPORTED',
  OTHER: 'OTHER'
} as const

export type Gender = (typeof Gender)[keyof typeof Gender]


export const ELStatus = {
  EL: 'EL',
  FORMER_EL: 'FORMER_EL',
  NOT_EL: 'NOT_EL',
  NOT_REPORTED: 'NOT_REPORTED'
} as const

export type ELStatus = (typeof ELStatus)[keyof typeof ELStatus]


export const DisabilityStatus = {
  HAS_DISABILITY: 'HAS_DISABILITY',
  NO_DISABILITY: 'NO_DISABILITY',
  NOT_REPORTED: 'NOT_REPORTED'
} as const

export type DisabilityStatus = (typeof DisabilityStatus)[keyof typeof DisabilityStatus]


export const EconomicDisadvantageStatus = {
  ECONOMICALLY_DISADVANTAGED: 'ECONOMICALLY_DISADVANTAGED',
  NOT_ECONOMICALLY_DISADVANTAGED: 'NOT_ECONOMICALLY_DISADVANTAGED',
  NOT_REPORTED: 'NOT_REPORTED'
} as const

export type EconomicDisadvantageStatus = (typeof EconomicDisadvantageStatus)[keyof typeof EconomicDisadvantageStatus]


export const RaceCategory = {
  AMERICAN_INDIAN_OR_ALASKA_NATIVE: 'AMERICAN_INDIAN_OR_ALASKA_NATIVE',
  ASIAN: 'ASIAN',
  BLACK_OR_AFRICAN_AMERICAN: 'BLACK_OR_AFRICAN_AMERICAN',
  NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER: 'NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER',
  WHITE: 'WHITE',
  TWO_OR_MORE_RACES: 'TWO_OR_MORE_RACES',
  OTHER: 'OTHER',
  NOT_REPORTED: 'NOT_REPORTED'
} as const

export type RaceCategory = (typeof RaceCategory)[keyof typeof RaceCategory]


export const LanguageProficiency = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  PROFICIENT: 'PROFICIENT',
  NOT_ASSESSED: 'NOT_ASSESSED',
  NOT_REPORTED: 'NOT_REPORTED'
} as const

export type LanguageProficiency = (typeof LanguageProficiency)[keyof typeof LanguageProficiency]


export const TermType = {
  SEMESTER: 'SEMESTER',
  TRIMESTER: 'TRIMESTER',
  QUARTER: 'QUARTER',
  YEAR: 'YEAR',
  SUMMER: 'SUMMER',
  OTHER: 'OTHER'
} as const

export type TermType = (typeof TermType)[keyof typeof TermType]


export const CalendarDayType = {
  INSTRUCTIONAL: 'INSTRUCTIONAL',
  HOLIDAY: 'HOLIDAY',
  WEEKEND: 'WEEKEND',
  IN_SERVICE: 'IN_SERVICE',
  EARLY_RELEASE: 'EARLY_RELEASE',
  WEATHER_CLOSURE: 'WEATHER_CLOSURE',
  OTHER: 'OTHER'
} as const

export type CalendarDayType = (typeof CalendarDayType)[keyof typeof CalendarDayType]


export const CourseSubject = {
  MATH: 'MATH',
  ENGLISH_LANGUAGE_ARTS: 'ENGLISH_LANGUAGE_ARTS',
  SCIENCE: 'SCIENCE',
  SOCIAL_STUDIES: 'SOCIAL_STUDIES',
  WORLD_LANGUAGE: 'WORLD_LANGUAGE',
  ARTS: 'ARTS',
  PHYSICAL_EDUCATION: 'PHYSICAL_EDUCATION',
  CTE: 'CTE',
  OTHER: 'OTHER',
  NOT_REPORTED: 'NOT_REPORTED'
} as const

export type CourseSubject = (typeof CourseSubject)[keyof typeof CourseSubject]


export const CourseStatus = {
  ACTIVE: 'ACTIVE',
  RETIRED: 'RETIRED',
  DRAFT: 'DRAFT'
} as const

export type CourseStatus = (typeof CourseStatus)[keyof typeof CourseStatus]


export const SectionStatus = {
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED'
} as const

export type SectionStatus = (typeof SectionStatus)[keyof typeof SectionStatus]


export const GradeState = {
  IN_PROGRESS: 'IN_PROGRESS',
  POSTED: 'POSTED'
} as const

export type GradeState = (typeof GradeState)[keyof typeof GradeState]


export const CalendarSource = {
  GOOGLE: 'GOOGLE'
} as const

export type CalendarSource = (typeof CalendarSource)[keyof typeof CalendarSource]


export const CalendarEventVisibility = {
  DEFAULT: 'DEFAULT',
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE',
  CONFIDENTIAL: 'CONFIDENTIAL'
} as const

export type CalendarEventVisibility = (typeof CalendarEventVisibility)[keyof typeof CalendarEventVisibility]


export const CalendarEventStatus = {
  CONFIRMED: 'CONFIRMED',
  TENTATIVE: 'TENTATIVE',
  CANCELLED: 'CANCELLED'
} as const

export type CalendarEventStatus = (typeof CalendarEventStatus)[keyof typeof CalendarEventStatus]


export const CalendarAttendeeResponse = {
  NEEDS_ACTION: 'NEEDS_ACTION',
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
  TENTATIVE: 'TENTATIVE'
} as const

export type CalendarAttendeeResponse = (typeof CalendarAttendeeResponse)[keyof typeof CalendarAttendeeResponse]


export const ConferenceProvider = {
  GOOGLE_MEET: 'GOOGLE_MEET',
  ZOOM: 'ZOOM',
  MS_TEAMS: 'MS_TEAMS',
  WEBEX: 'WEBEX',
  OTHER: 'OTHER'
} as const

export type ConferenceProvider = (typeof ConferenceProvider)[keyof typeof ConferenceProvider]


export const BoardType = {
  KANBAN: 'KANBAN',
  DASHBOARD: 'DASHBOARD',
  ACTIONBOARD: 'ACTIONBOARD'
} as const

export type BoardType = (typeof BoardType)[keyof typeof BoardType]


export const BoardFilterParentSource = {
  NONE: 'NONE',
  SPECIFIC: 'SPECIFIC',
  BOARD_AOR: 'BOARD_AOR'
} as const

export type BoardFilterParentSource = (typeof BoardFilterParentSource)[keyof typeof BoardFilterParentSource]


export const SlackBackfillStatus = {
  pending: 'pending',
  in_progress: 'in_progress',
  completed: 'completed',
  failed: 'failed'
} as const

export type SlackBackfillStatus = (typeof SlackBackfillStatus)[keyof typeof SlackBackfillStatus]


export const EvidenceSource = {
  MANUAL: 'MANUAL',
  INFERRED: 'INFERRED',
  AGGREGATED: 'AGGREGATED'
} as const

export type EvidenceSource = (typeof EvidenceSource)[keyof typeof EvidenceSource]


export const PulseKind = {
  REFLECTION: 'REFLECTION',
  MEETING: 'MEETING',
  SURVEY: 'SURVEY',
  NOTETAKER: 'NOTETAKER',
  QUICK: 'QUICK',
  CHECK: 'CHECK',
  SYSTEM: 'SYSTEM',
  CHAT: 'CHAT'
} as const

export type PulseKind = (typeof PulseKind)[keyof typeof PulseKind]


export const BeliefBasis = {
  data: 'data',
  experience: 'experience',
  intuition: 'intuition',
  precedent: 'precedent',
  pressure: 'pressure'
} as const

export type BeliefBasis = (typeof BeliefBasis)[keyof typeof BeliefBasis]


export const PersonRelationshipSource = {
  SELF_REPORTED: 'SELF_REPORTED',
  DERIVED: 'DERIVED'
} as const

export type PersonRelationshipSource = (typeof PersonRelationshipSource)[keyof typeof PersonRelationshipSource]


export const ContextResearchStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  READY: 'READY',
  FAILED: 'FAILED'
} as const

export type ContextResearchStatus = (typeof ContextResearchStatus)[keyof typeof ContextResearchStatus]


export const RosterCandidateStatus = {
  PENDING: 'PENDING',
  CONFIRMED: 'CONFIRMED',
  UNSURE: 'UNSURE',
  REJECTED: 'REJECTED'
} as const

export type RosterCandidateStatus = (typeof RosterCandidateStatus)[keyof typeof RosterCandidateStatus]


export const SaiReportFileKind = {
  USAGE: 'USAGE',
  ALERTS: 'ALERTS'
} as const

export type SaiReportFileKind = (typeof SaiReportFileKind)[keyof typeof SaiReportFileKind]


export const SaiMetricGrain = {
  TOTAL: 'TOTAL',
  PERIOD: 'PERIOD'
} as const

export type SaiMetricGrain = (typeof SaiMetricGrain)[keyof typeof SaiMetricGrain]


export const SaiCatalogKind = {
  TOOL: 'TOOL',
  SPACE: 'SPACE'
} as const

export type SaiCatalogKind = (typeof SaiCatalogKind)[keyof typeof SaiCatalogKind]


export const OrgUnitSource = {
  RESEARCH: 'RESEARCH',
  IMPORT: 'IMPORT',
  ROSTER: 'ROSTER',
  HRIS: 'HRIS',
  MANUAL: 'MANUAL'
} as const

export type OrgUnitSource = (typeof OrgUnitSource)[keyof typeof OrgUnitSource]


export const SchoolLevel = {
  ELEMENTARY: 'ELEMENTARY',
  MIDDLE: 'MIDDLE',
  HIGH: 'HIGH',
  ALTERNATIVE: 'ALTERNATIVE',
  OTHER: 'OTHER'
} as const

export type SchoolLevel = (typeof SchoolLevel)[keyof typeof SchoolLevel]
